import { InjectionToken } from '@angular/core';
import { IonicComponentRef } from '@lyceo/shared/util-models';

export const NEW_TASK_MODAL: InjectionToken<IonicComponentRef> =
  new InjectionToken<IonicComponentRef>('NEW_TASK_MODAL');
export const TASK_MODAL: InjectionToken<IonicComponentRef> =
  new InjectionToken<IonicComponentRef>('TASK_MODAL');
export const REFLECTION_MODAL: InjectionToken<IonicComponentRef> =
  new InjectionToken<IonicComponentRef>('REFLECTION_MODAL');
